import {
  faFlag,
  faFutbol,
  faHandPaper,
  faMicrophoneAlt,
  faPeopleArrows,
  faPlus,
  faStopwatch,
  faUsers
} from "@fortawesome/free-solid-svg-icons";
import React, { useEffect, useState } from "react";
import style from "../assets/css/page/MatchLive.module.css";
import FormSanction from "../components/Form/FormSanction";
import FormFoul from "../components/Form/FormFoul";
import FormGoal from "../components/Form/FormGoal";
import FormChange from "../components/Form/FormChange";
import InputCheck from "../components/Input/InputCheck";
import FormStatus from "../components/Form/FormStatus";
import FormLive from "../components/Form/FormLive";
import { useLocation } from "react-router";
import FormExtraPoint from "../components/Form/FormExtraPoint";
import FormPlayers from "../components/Form/FormPlayers";
import { GET_MATCH } from "../graphql/queries";
import { useQuery } from "@apollo/client";
import Loading from "../components/Loading";

function MatchLive() {
  const location = useLocation();
  const idMatch = location.state.match;
  const [status, setStatus] = useState(1);
  const [playersLocal, setPlayersLocal] = useState([]);
  const [playersVisit, setPlayersVisit] = useState([]);

  const { data, loading } = useQuery(GET_MATCH, {
    variables: {
      IdMatch: idMatch,
      State: "LIVE"
    }
  });

  const teamsOptions = [
    { value: "1", label: data?.match?.local?.name },
    { value: "2", label: data?.match?.visit?.name }
  ];

  const showForm = (form) => {
    if (form === 1)
      return (
        <FormGoal
          idMatch={data?.match?.id}
          typeMatch={data?.match?.type}
          statusMatch={data?.match?.StatusMatch}
          teams={teamsOptions}
          playersLocal={playersLocal}
          playersVisit={playersVisit}
        />
      );
    if (form === 2)
      return (
        <FormGoal
          idMatch={data?.match?.id}
          teams={teamsOptions}
          playersLocal={playersLocal}
          playersVisit={playersVisit}
          autoGoal
        />
      );
    if (form === 3)
      return (
        <FormFoul
          idMatch={data?.match?.id}
          typeMatch={data.type}
          teams={teamsOptions}
          playersLocal={playersLocal}
          playersVisit={playersVisit}
        />
      );
    if (form === 4)
      return <FormSanction idMatch={data?.match?.id} teams={teamsOptions} />;
    if (form === 5)
      return (
        <FormChange
          idMatch={data?.match?.id}
          teams={teamsOptions}
          playersLocal={playersLocal}
          playersVisit={playersVisit}
        />
      );
    if (form === 6)
      return <FormExtraPoint idMatch={data?.match?.id} teams={teamsOptions} />;
    if (form === 7)
      return (
        <FormPlayers
          idMatch={data?.match?.id}
          playersLocal={playersLocal}
          playersVisit={playersVisit}
        />
      );
    if (form === 8)
      return (
        <FormStatus typeMatch={data?.match?.type} idMatch={data?.match?.id} />
      );
    if (form === 9) return <FormLive idMatch={data?.match?.id} />;
  };

  useEffect(() => {
    data?.match?.local?.players.forEach((player) => {
      playersLocal.push({
        value: player.id,
        label: `${player.name} ${player.app}`
      });
    });
    setPlayersLocal(playersLocal);
  }, [data, playersLocal]);

  useEffect(() => {
    data?.match?.visit?.players.forEach((player) => {
      playersVisit.push({
        value: player.id,
        label: `${player.name} ${player.app}`
      });
    });

    setPlayersVisit(playersVisit);
  }, [data, playersVisit]);

  if (loading) return <Loading />;

  return (
    <div className={style.container}>
      <div className={style.infoMatch}>
        <h1 className={style.match}>{`${data.match.local.name} vs ${
          data.match.visit.name
        } | ${
          data.match.type !== "jornada"
            ? data.match.type
            : "jornada " + data.match.day
        } | ${data.match.StatusMatch}`}</h1>
      </div>
      <div className={style.contAction}>
        <InputCheck
          title="Gol"
          icon={faFutbol}
          checked
          onClick={() => setStatus(1)}
        />
        <InputCheck
          title="Auto gol"
          icon={faFutbol}
          onClick={() => setStatus(2)}
        />
        <InputCheck
          title="Falta"
          icon={faHandPaper}
          onClick={() => setStatus(3)}
        />
        <InputCheck
          title="Sanción"
          icon={faFlag}
          onClick={() => setStatus(4)}
        />
        <InputCheck
          title="Cambio"
          icon={faPeopleArrows}
          onClick={() => setStatus(5)}
        />
        <InputCheck
          title="P. Extra"
          icon={faPlus}
          onClick={() => setStatus(6)}
        />
        <InputCheck
          title="Jugador"
          icon={faUsers}
          onClick={() => setStatus(7)}
        />
        <InputCheck
          title="Estatus"
          icon={faStopwatch}
          onClick={() => setStatus(8)}
        />
        <InputCheck
          title="Live"
          icon={faMicrophoneAlt}
          onClick={() => setStatus(9)}
        />
      </div>
      <div className={style.contForm}>{showForm(status)}</div>
    </div>
  );
}

export default MatchLive;
